// @flow
import type { TemplateItem, AudienceItem } from '../../../components/AdvertisementTemplatesTable'

type State = {|
  isLoading: boolean,
  checkedTemplateIds: Array<number>,
  archivedTemplateIds: Array<number>,
  isModalOpen: boolean,
  templateList: Array<TemplateItem>,
  audienceList: Array<AudienceItem>,
  tableGroupType: string
|}

type PatchAction = {|
  +type: 'TEMPLATES_TABLE.PATCH',
  +state: $Shape<State>
|}

type Action = PatchAction

export type { State }

const initialState: State = {
  isLoading: false,
  checkedTemplateIds: [],
  archivedTemplateIds: [],
  isModalOpen: false,
  templateList: [],
  audienceList: [],
  tableGroupType: 'templates'
}

export function patch(diff: $Shape<State>): Action {
  return {
    type: 'TEMPLATES_TABLE.PATCH',
    state: diff
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'TEMPLATES_TABLE.PATCH':
      return { ...state, ...action.state }
    default:
      return state
  }
}
